var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"label":"Placeholder","hide-details":""},model:{value:(_vm.localValue.placeholder),callback:function ($$v) {_vm.$set(_vm.localValue, "placeholder", $$v)},expression:"localValue.placeholder"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }